import React, { useState, useEffect } from 'react';
import InputField from '../../../../common/InputField';
import SelectOption from '../../../../common/SelectOption';
import MonthlyPricingOption from '../HotDesk/MonthlyPricingOption/MonthlyPricingOption';
import WeeklyPricingOption from '../HotDesk/WeeklyPricingOption/WeeklyPricingOption';
import DailyPricingOption from '../HotDesk/DailyPricingOption/DailyPricingOption';
import CommonCheckBox from '../../../../common/CommonCheckBox';
import TimeRangePicker from '../../../../common/TimePicker/TimeRangePicker';
import FieldName from '../../../../common/FieldName';
import InputNumberField from '../../../../common/InputNumberField';
import { useDispatch, useSelector } from 'react-redux';
import Amenities from '../Amenities/Amenities';
import Addons from '../Addons/Addons';
import KeepInMind from '../KeepInMind/KeepInMind';
import { Form, Row, Col } from 'antd';
import { dailyPricingOptionValidation } from '../../../../../helper/spaceFormValidation';
import { days, SPACE_CATEGORY, SPACE_PAYMENT_OPTIONS } from '../../../../common/constants';
import {
    discountNameValidation, discountPercentageValidation,
    numberOfSeatValidation,
    pricePerSeatValidation
} from "../../../../../helper/FeildValidations";
import Packages from "../Packages/Packages";
import { getPricingOptionsDayArray } from '../../SpaceAction';

const DedicatedDesk = ({ index, form, activityId, name, currency, activity, isEdit, isVirtualOffice, filteredPaymentOptions}) => {
  const rules = [
    {
      required: true,
      message: 'Please Fill Input Field!',
    },
  ];
  const months = [1, 2, 3, 4, 5, 6, 7, 8];
  const formFields = isEdit ? form.getFieldValue() : null;
  const dispatch = useDispatch();
  const [isFullDayAccess, setFullDayAccess] = useState(false);
  const [timePickers, setTimePickers] = useState([{ beginTime: '3:00 am', endTime: '5:00 pm' }]);
  const [selectedDays, setSelectedDays] = useState([]);
  const cancellationPolicies = useSelector(
    (state) => state.space?.cancellationPolicies?.data || []
  );
  // const paymentOptions = useSelector((state) => state.space?.paymentOptions?.data || []);

  const allPaymentOptions = useSelector((state) => state.space?.paymentOptions?.data || []);
  const paymentOptions = filteredPaymentOptions || allPaymentOptions.filter(i => i.name === 'Daily' || i.name === 'Weekly' || i.name === 'Monthly');

  const savings = useSelector((state) => state.space?.savings?.data || []);
  const [isDiscountVisible, setDiscountVisible] = useState(false);
  const [price, setPrice] = useState(null);
  const [dateSelectionOptions, setDateSelectionOptions] = useState(days);
  const [count, setCount] = useState([1])
  const [selectedPricingOptions, setPricingOptions] = useState(isEdit ? formFields.events[index].chargings?.map(c => c.chargingType.id) : []);
  // const paymentOptions = useSelector((state) => state.space?.paymentOptions?.data.filter(i =>i.name === 'Daily' || i.name === 'Weekly' || i.name === 'Monthly') || []);
  let weeklyPricingOptionData = {};
  let dailyPricingOptionData = {};
  let monthlyPricingOptionData = {};
  if(isEdit && formFields?.events){
    weeklyPricingOptionData = formFields.events[index]?.chargings?.find(c => c.chargingTypeDesc.name === 'Weekly') || {}
    dailyPricingOptionData = formFields.events[index]?.chargings?.find(c => c.chargingTypeDesc.name === 'Daily') || {}
    monthlyPricingOptionData = formFields.events[index]?.chargings?.find(c => c.chargingTypeDesc.name === 'Monthly') || {}
  }

  useEffect(() => {
    setDateSelectionOptions(dailyPricingOptionValidation(days, selectedDays));
  }, [selectedDays]);

  const dedicatedDeskIndex = 0;
  const paymentOptionIndex = 0;
  useEffect(() => {
    if(!isEdit){
      form.setFieldsValue({
        events: [
          {
            eventType: {
              id: activityId,
            },
          },
        ],
      });
    }
  }, []);

  useEffect(() => {
    if(isEdit) {
      if(formFields?.events[dedicatedDeskIndex]?.chargings[paymentOptionIndex]?.discounts)
      setDiscountVisible(formFields?.events[dedicatedDeskIndex]?.chargings[paymentOptionIndex]?.discounts[0]?.id ? true : false );
      setFullDayAccess(formFields?.events[dedicatedDeskIndex]?.chargings[paymentOptionIndex]?.access24by7 || false);
      setSelectedDays(formFields?.events[dedicatedDeskIndex]?.chargings[paymentOptionIndex]?.days);
    }
  },[formFields?.events[index]]);

  // const deselectItems = (item) => {
  //   setSelectedDays(selectedDays.filter((i) => i !== item));
  // };

  const getPaymentOptionId = () => {
    const { id } = paymentOptions.find((i) => i.name === 'Monthly');
    return id;
  };

  const handleSelected = (option) => {
    setPricingOptions([...selectedPricingOptions, option]);
  };
  const deselectItems = (option) => {
    const changeValue = selectedPricingOptions.filter((i) => i !== option);
    setPricingOptions(changeValue);
  };
  const getPaymentOptionName = (id) => {
    const { name } = paymentOptions.find((i) => i.id === id);
    return name;
  };

  useEffect(()=>{
    dispatch(getPricingOptionsDayArray(selectedPricingOptions));
  },[selectedPricingOptions])

  // useEffect(() => {
  //   if(!isEdit){
  //     let getEvents = form.getFieldValue('events');
  //     const events = getEvents.map((i) => {
  //       return {
  //         eventType: i.eventType,
  //         chargings: [{ chargingType: { id: getPaymentOptionId() } }],
  //       };
  //     });
  //     form.setFieldsValue({
  //       events,
  //     });
  //   }
  // }, [paymentOptions]);

  return (
    <div className="basic-details-wrapper">
      <Form.Item name={['events', index, 'eventType', 'id']}> </Form.Item>

      <InputField
        name={['events', index, 'seatArrangements', 0, 'max']}
        label={'Number Of Seats'}
        rules={numberOfSeatValidation}
      />

      <SelectOption
        isMultiple={false}
        name={['events', index, 'cancellationPolicy', 'id']}
        placeholder={'Cancellation Policies'}
        rules={rules}
        label={'Cancellation Policies'}
        values={cancellationPolicies}
        valueName={'id'}
        labelName={'name'}
        handleOnSelect={null}
      />
      {/* <Form.Item
        name={['events', dedicatedDeskIndex, 'chargings', paymentOptionIndex, 'chargingType', 'id']}
      ></Form.Item> */}

      <SelectOption
        isMultiple={true}
        // name={['events', index, 'pricingOption']}
        placeholder={'Charging Types'}
        rules={rules}
        label={'Charging Types'}
        values={paymentOptions}
        handleOnSelect={handleSelected}
        handleOnDeselect={deselectItems}
        labelName={'name'}
        valueName={'id'}
        value={selectedPricingOptions}
      />

      {selectedPricingOptions.map((option, index) => {
        if (getPaymentOptionName(option) === SPACE_PAYMENT_OPTIONS.DAILY) {
          return (
            <Packages
              form={form}
              paymentOption={SPACE_PAYMENT_OPTIONS.DAILY}
              packageCategory={SPACE_CATEGORY.WORK}
              hotDeskIndex={0}
              pricingOptionIndex={index}
              currency={currency}
              isEdit={isEdit}
              privateOffice={true}
            />
          );
        } else if (getPaymentOptionName(option) === SPACE_PAYMENT_OPTIONS.WEEKLY) {
          return (
            <Packages
              form={form}
              paymentOption={SPACE_PAYMENT_OPTIONS.WEEKLY}
              packageCategory={SPACE_CATEGORY.WORK}
              hotDeskIndex={0}
              pricingOptionIndex={index}
              currency={currency}
              isEdit={isEdit}
              privateOffice={true}
            />
          );
        } else if (getPaymentOptionName(option) === SPACE_PAYMENT_OPTIONS.MONTHLY) {
          return (
            <Packages
              form={form}
              paymentOption={SPACE_PAYMENT_OPTIONS.MONTHLY}
              packageCategory={SPACE_CATEGORY.WORK}
              hotDeskIndex={0}
              pricingOptionIndex={index}
              currency={currency}
              isEdit={isEdit}
              privateOffice={true}
            />

          );
        }
      })}

      {selectedPricingOptions?.length > 0 ? selectedPricingOptions.map((option, index) => {
        if (getPaymentOptionName(option) === 'Daily') {
          return (
            <DailyPricingOption
              form={form}
              hotdeskIndex={0}
              pricingOptionIndex={index}
              currency={currency}
              paymentOptionId={option}
              values={isEdit ? dailyPricingOptionData : null}
              isEdit={isEdit}
            />
          );
        } else if (getPaymentOptionName(option) === 'Weekly') {
          return (
            <WeeklyPricingOption
              form={form}
              hotdeskIndex={0}
              pricingOptionIndex={index}
              currency={currency}
              paymentOptionId={option}
              values={isEdit ? weeklyPricingOptionData : null}
              isEdit={isEdit}
            />
          );
        }
        else if (getPaymentOptionName(option) === 'Monthly') {
          return (
            <MonthlyPricingOption
              form={form}
              hotdeskIndex={0}
              pricingOptionIndex={index}
              currency={currency}
              paymentOptionId={option}
              values={isEdit ? monthlyPricingOptionData : null}
              isEdit={isEdit}
            />
          );
        }
      }) : null}
      {/* <Row>
        <Col offset={8}></Col>
        <Col span={16}>
          <CommonCheckBox
            name={[
              'events',
              dedicatedDeskIndex,
              'chargings',
              paymentOptionIndex,
              'proratedFirstMonth',
            ]}
            label={'Price prorated for the first month'}
            handleOnChange={null}
          />
        </Col>
      </Row>
      <SelectOption
        isMultiple={false}
        name={[
          'events',
          dedicatedDeskIndex,
          'chargings',
          paymentOptionIndex,
          'minimumBookingPeriod',
        ]}
        placeholder={'Month'}
        rules={rules}
        label={'Minimum Booking Period (Months)'}
        values={months}
        handleOnSelect={null}
      />
      <SelectOption
        isMultiple={false}
        name={['events', dedicatedDeskIndex, 'chargings', paymentOptionIndex, 'earlyTermination']}
        placeholder={'Month'}
        rules={rules}
        label={'Early Termination Period (Months)'}
        values={months}
        handleOnSelect={null}
      />
      <SelectOption
        isMultiple={false}
        name={['events', dedicatedDeskIndex, 'chargings', paymentOptionIndex, 'securityDeposit']}
        placeholder={'Month'}
        rules={rules}
        label={'Security Deposit (Months)'}
        values={months}
        handleOnSelect={null}
      />
      <Row>
      <Col offset={8}></Col>
      <Col span={16}>
      <CommonCheckBox
        label={'Discount visible ?'}
        handleOnChange={(e) => setDiscountVisible(e.target.checked)}
        checked={isDiscountVisible}
      />
      </Col>
      </Row>

      {isDiscountVisible && <>
        <SelectOption
        isMultiple={false}
        name={[
          'events',
          dedicatedDeskIndex,
          'chargings',
          paymentOptionIndex,
          'discounts',
          0,
          'id',
        ]}
        placeholder={'Name'}
        rules={discountNameValidation}
        label={'Discount Name'}
        values={savings}
        handleOnSelect={null}
        labelName={'name'}
        valueName={'id'}
      />  
      
      <SelectOption
        isMultiple={false}
        name={[
          'events',
          dedicatedDeskIndex,
          'chargings',
          paymentOptionIndex,
          'discounts',
          0,
          'term',
        ]}
        placeholder={'Month'}
        rules={rules}
        label={'Discount Applicable (Months)'}
        values={months}
        handleOnSelect={null}
      />

      <InputNumberField
        name={[
          'events',
          dedicatedDeskIndex,
          'chargings',
          paymentOptionIndex,
          'discounts',
          0,
          'amount',
        ]}
        label={'Discount %'}
        rules={discountPercentageValidation}
      />
      </>}
     
      <InputField
        name={['events', dedicatedDeskIndex, 'chargings', paymentOptionIndex, 'amount']}
        label={activity === "Dedicated Desk" ? 'Price Per seat' : "Price"}
        rules={pricePerSeatValidation}
        handleOnChange={(e) => setPrice(e.target.value)}
      />

      <Row>
        <Col offset={8}></Col>
        <Col span={16}>
          <CommonCheckBox
            name={['events', dedicatedDeskIndex, 'chargings', paymentOptionIndex, 'access24by7']}
            label={'24/7 Access'}
            handleOnChange={(e) => setFullDayAccess(e.target.checked)}
          />
        </Col>
      </Row>
      {!isFullDayAccess && (
        <SelectOption
          isMultiple={true}
          name={['events', dedicatedDeskIndex, 'chargings', paymentOptionIndex, 'days']}
          placeholder={'Days'}
          rules={rules}
          label={'Days'}
          values={dateSelectionOptions}
          handleOnSelect={(days) => setSelectedDays([...selectedDays, days])}
          handleOnDeselect={deselectItems}
        />
      )}
      {!isFullDayAccess &&
        selectedDays.map((day, index) => (
          <>
            <Form.Item
              label={day}
              name={[
                'events',
                dedicatedDeskIndex,
                'chargings',
                paymentOptionIndex,
                'pricingOptions',
                index,
              ]}
            >
              <TimeRangePicker
                key={index}
                pickers={timePickers}
                setTimePicker={setTimePickers}
                index={index}
                day={day}
                currency={currency}
                seatPrice={price}
                initialValue={formFields?.events[dedicatedDeskIndex]?.chargings[paymentOptionIndex]?.pricingOptions.find(p => p.name === day)}
              />
            </Form.Item>
          </> 
        ))}
        */}
      <Amenities name={['events', 0, 'amenities']} selectedPricingOptions={selectedPricingOptions} form={form} activity={activity}/>
      {isEdit ? (<><Addons name={['events', 0, 'addOns']} formAddOns={formFields.events[index].spaceAddOns} isEdit={isEdit} />
      <KeepInMind name={['events', 0, 'keepInMind']} formKeepInMinds={formFields.events[index].keepInMind} isEdit={isEdit}  /></>):
      (<><Addons name={['events', 0, 'addOns']} />
      <KeepInMind name={['events', 0, 'keepInMind']}   /></>)}
    </div>
  );
};

export default DedicatedDesk;
